/*
  GILLSEE CUP 岐阜大会ページ（sections/c__gillsee-cup-gifu-2026.liquid 用）
  栗林さん提供の gifu.js をShopifyに移したもの。

  Shopify向けに変えた点
  ・受付終了のとき（data-closed="true"）は残り人数を取りに行かない
  ・送信を text/plain にした（GASは application/json だとブラウザ側で弾かれるため）
  ・送信後の移動先は、GASが返さなければセクション設定のURLを使う
*/
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.gc-gifu-v2');
  if (!root) return;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const mapButtons = [...root.querySelectorAll('.gc-map-tabs button')];
  const mapFigures = [...root.querySelectorAll('.gc-map-images figure')];
  mapButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      mapButtons.forEach(item => item.classList.remove('active'));
      mapFigures.forEach(item => item.classList.remove('active'));
      button.classList.add('active');
      mapFigures[index]?.classList.add('active');
      button.classList.remove('gc-tab-hit');
      requestAnimationFrame(() => button.classList.add('gc-tab-hit'));
    });
  });

  const form = root.querySelector('.gc-entry-form');
  const capacity = root.querySelector('.gc-entry-capacity');
  const capacityCount = capacity?.querySelector('strong b');
  const capacityBar = capacity?.querySelector('.gc-entry-capacity__bar i');
  const capacityMessage = capacity?.querySelector('p');
  const closedMessage = '<strong>エントリーは定員に達しました！</strong><span>沢山のご参加ありがとうございました！</span>';
  const setFormClosed = closed => {
    if (!form) return;
    form.classList.toggle('gc-entry-form--closed', closed);
    [...form.elements].forEach(field => field.disabled = closed);
    const button = form.querySelector('button[type="submit"]');
    if (button && closed) button.textContent = '受付は終了しました';
    if (button && !closed && button.textContent === '受付は終了しました') {
      button.textContent = '無料でエントリーする';
    }
  };
  const limitFallback = Number(capacity?.dataset.limit) || 150;
  const refreshCapacity = async () => {
    if (!capacity?.dataset.statusEndpoint || capacity.dataset.closed === 'true') return;
    try {
      const response = await fetch(capacity.dataset.statusEndpoint, {cache: 'no-store'});
      const status = await response.json();
      if (!response.ok || !status.ok) throw new Error('status error');
      const count = Math.min(Number(status.count) || 0, Number(status.limit) || limitFallback);
      const remaining = Math.max(0, Number(status.remaining) || 0);
      capacityCount.textContent = count;
      capacityBar.style.width = `${Math.min(100, count / status.limit * 100)}%`;
      capacity.classList.toggle('is-low', remaining > 0 && remaining <= 10);
      capacity.classList.toggle('is-closed', Boolean(status.closed));
      if (status.closed) {
        capacityMessage.innerHTML = closedMessage;
      } else {
        capacityMessage.textContent = `定員まで、あと${remaining}名`;
      }
      setFormClosed(Boolean(status.closed));
    } catch (_) {
      capacityMessage.textContent = '残り人数を取得できませんでした。フォームからお申し込みください。';
    }
  };
  if (capacity?.dataset.closed === 'true') {
    setFormClosed(true);
  } else {
    refreshCapacity();
    window.setInterval(refreshCapacity, 30000);
  }

  const regulationList = root.querySelector('.gc-regulations__list');
  const regulationToggle = root.querySelector('.gc-regulations__toggle-all');
  const regulationItems = [...(regulationList?.querySelectorAll('details') || [])];
  regulationToggle?.addEventListener('click', () => {
    const shouldOpen = !regulationItems.every(item => item.open);
    regulationItems.forEach(item => item.open = shouldOpen);
    regulationToggle.setAttribute('aria-expanded', String(shouldOpen));
    regulationToggle.textContent = shouldOpen ? 'すべて閉じる' : '全項目を開く';
  });

  form?.addEventListener('submit', async event => {
    event.preventDefault();
    const errorBox = form.querySelector('.gc-entry-errors');
    const submitButton = form.querySelector('button');
    const data = Object.fromEntries(new FormData(form));
    data.guardian = form.elements.guardian.checked;
    data.agree = form.elements.agree.checked;
    errorBox.hidden = true;
    submitButton.disabled = true;
    submitButton.textContent = '送信しています…';

    try {
      const response = await fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: {'Content-Type': 'text/plain;charset=utf-8'},
        body: JSON.stringify(data)
      });
      const result = await response.json();
      if (!response.ok || !result.ok) {
        if (result.closed) {
          capacity?.classList.add('is-closed');
          if (capacityMessage) capacityMessage.innerHTML = closedMessage;
          if (capacityCount) capacityCount.textContent = result.limit || limitFallback;
          if (capacityBar) capacityBar.style.width = '100%';
          setFormClosed(true);
        }
        throw new Error((result.errors || [result.message || '送信できませんでした。']).join('\n'));
      }
      location.assign(result.redirect || form.dataset.redirect || '/');
    } catch (error) {
      errorBox.innerHTML = '<strong>送信できませんでした</strong><br>' +
        String(error.message).replaceAll('\n', '<br>');
      errorBox.hidden = false;
      if (!form.classList.contains('gc-entry-form--closed')) {
        submitButton.disabled = false;
        submitButton.textContent = '無料でエントリーする';
      }
    }
  });

  const sections = [...root.querySelectorAll(':scope > section')];
  sections.forEach((section, index) => {
    section.classList.add('gc-fx-section', index % 2 ? 'gc-fx-odd' : 'gc-fx-even');
    section.dataset.fxNumber = String(index + 1).padStart(2, '0');
  });

  const targets = [...root.querySelectorAll(
    '.gc-section .gc-wrap, .gc-logo-card, .gc-prize-teaser > *, ' +
    '.gc-profile-v2 > *, .gc-photo-rule > *, .gc-panel, .gc-brand__grid > *'
  )];
  targets.forEach((target, index) => {
    target.classList.add('gc-v2-motion');
    if (target.matches('[class*="photo"], .gc-prize-teaser__visual, .gc-brand__grid > *')) {
      target.classList.add(index % 2 ? 'right' : 'left');
    }
    target.style.transitionDelay = `${(index % 4) * .07}s`;
  });

  if (reduce) {
    targets.forEach(target => target.classList.add('in'));
    sections.forEach(section => section.classList.add('gc-section-live'));
  } else {
    const targetObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        targetObserver.unobserve(entry.target);
      });
    }, {threshold: .1});
    targets.forEach(target => targetObserver.observe(target));

    const sectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('gc-section-live');
      });
    }, {threshold: .18});
    sections.forEach(section => sectionObserver.observe(section));
  }

  if (!reduce && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    root.querySelectorAll('.gc-logo-card').forEach(card => {
      card.addEventListener('pointermove', event => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        card.style.setProperty('--tilt-x', `${y * -8}deg`);
        card.style.setProperty('--tilt-y', `${x * 10}deg`);
        card.style.setProperty('--shine-x', `${(x + .5) * 100}%`);
        card.style.setProperty('--shine-y', `${(y + .5) * 100}%`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.removeProperty('--tilt-x');
        card.style.removeProperty('--tilt-y');
      });
    });
  }

  const progress = document.createElement('div');
  progress.className = 'gc-gifu-v2-progress';
  document.body.appendChild(progress);
  const hero = root.querySelector('.gc-hero');
  let busy = false;
  const paint = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    progress.style.width = `${max ? scrollY / max * 100 : 0}%`;
    if (hero && !reduce && scrollY < innerHeight * 1.2) {
      hero.style.setProperty('--para', `${scrollY * .14}px`);
      hero.style.setProperty('--hero-scale', String(1 + Math.min(scrollY / 9000, .045)));
    }
    busy = false;
  };
  addEventListener('scroll', () => {
    if (busy) return;
    requestAnimationFrame(paint);
    busy = true;
  }, {passive: true});
  paint();
});
